import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const ProjectCard = ({ slug, imgSrc, title, tags, classes }) => {
  return (
    <div
      className={
        "relative p-3 rounded-2xl bg-zinc-800 hover:bg-zinc-700/50 active:bg-zinc-700/60 ring-1 ring-inset ring-zinc-50/5 transition-colors " +
        (classes || "")
      }
    >
      <figure className="img-box aspect-video rounded-lg mb-3">
        <img
          src={imgSrc}
          alt={title}
          width={300}
          height={200}
          loading="lazy"
          className="img-cover"
        />
      </figure>
      <div className="flex items-center justify-between gap-4">
        <div>
          <h3 className="title-1 mb-2">{title}</h3>
          <div className="flex flex-wrap items-center gap-2">
            {Array.isArray(tags) ? (
              tags.map((label, index) => (
                <span
                  key={index}
                  className="h-8 text-sm text-zinc-400 bg-zinc-50/5 grid items-center px-3 rounded-lg"
                >
                  {label}
                </span>
              ))
            ) : (
              <p className="text-zinc-400">No tags available</p>
            )}
          </div>
        </div>

        <div className="w-11 h-11 rounded-lg grid place-items-center bg-sky-400 text-zinc-950 shrink-0">
          <div className="material-symbols-rounded">
            <span aria-hidden="true">arrow_outward</span>
          </div>
        </div>

        <Link
          to={`/projects/${slug}`}
          className="absolute inset-0"
          aria-label={`View details for ${title}`}
        />
      </div>
    </div>
  );
};

ProjectCard.propTypes = {
  slug: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tags: PropTypes.array.isRequired,
  classes: PropTypes.string,
};

export default ProjectCard;
